export const WELLNESS = 'SALON';
export const DENTAL = 'DENTAL';
export const ARTGALLERY = 'ART_GALLERY';
export const FITNESS = 'FITNESS';

export default [{
  label: 'Wellness',
  value: WELLNESS,
}, {
  label: 'Dental',
  value: DENTAL,
}, {
  label: 'Art Gallery',
  value: ARTGALLERY,
}, {
  label: 'Fitness',
  value: FITNESS,
}];
